import { combineReducers } from 'redux';

import types from './types';
import DiagramModel from 'src/model/diagram.model';
import ProductModel from 'src/model/product.model';

const id = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ID:
      return payload;

    default:
      return state;
  }
};

const modelID = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_MODEL_ID:
      return payload;

    default:
      return state;
  }
};

const diagrams = (
  state: DiagramModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: DiagramModel[];
  }
) => {
  switch (type) {
    case types.SET_DIAGRAMS:
      return payload;

    default:
      return state;
  }
};

const modelNumber = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_MODEL_NUMBER:
      return payload;

    default:
      return state;
  }
};

const modelName = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_MODEL_NAME:
      return payload;

    default:
      return state;
  }
};

const manufacturer = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_MANUFACTURER:
      return payload;

    default:
      return state;
  }
};

const brandName = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_BRAND_NAME:
      return payload;

    default:
      return state;
  }
};

const applianceType = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_APPLIANCE_TYPE:
      return payload;

    default:
      return state;
  }
};

const productionNumber = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_PRODUCTION_NUMBER:
      return payload;

    default:
      return state;
  }
};

const getModelIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.GET_MODEL_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const textFilter = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_TEXT_FILTER:
      return payload;

    default:
      return state;
  }
};

const activeDiagram = (
  state: number = -1,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_ACTIVE_DIAGRAM:
      return payload;

    default:
      return state;
  }
};

const activePart = (
  state: ProductModel | null = null,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_ACTIVE_PART:
      return payload;

    default:
      return state;
  }
};

const featuredProducts = (
  state: ProductModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: ProductModel[];
  }
) => {
  switch (type) {
    case types.SET_FEATURED_PRODUCTS:
      return payload;

    default:
      return state;
  }
};

const commonParts = (
  state: ProductModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: ProductModel[];
  }
) => {
  switch (type) {
    case types.SET_COMMON_PARTS:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  activeDiagram,
  id,
  modelID,
  diagrams,
  modelNumber,
  modelName,
  manufacturer,
  brandName,
  applianceType,
  productionNumber,
  getModelIsPending,
  textFilter,
  activePart,
  featuredProducts,
  commonParts
});
